import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

export const card = {
  namespaced: true,
  state: () => ({
    image: null,
    signature: null,
    biometrics: null,
    vaxcert: null,
    publicImage: null,
    publicSignature: null,
    publicBiometrics: null,
    publicVaxcert: null,
  }),
  getters: {
    getImage: (state) => state.image,
    getSignature: (state) => state.signature,
    getBiometrics: (state) => state.biometrics,
    getPublicImage: (state) => state.publicImage,
    getPublicSignature: (state) => state.publicSignature,
    getPublicBiometrics: (state) => state.publicBiometrics,
  },
  mutations: {
    //Set Images to the Card
    SET_IMAGE(state, imageBase64) {
      state.image = imageBase64;
    },
    SET_SIGNATURE(state, imageBase64) {
      state.signature = imageBase64;
    },
    SET_BIOMETRICS(state, imageBase64) {
      state.biometrics = imageBase64;
    },
    SET_VAXCERT: (state, data) => (state.vaxcert = data),

    //Delete Images from the database
    DELETE_IMAGE(state, targetImage) {
      if (state.image === targetImage) {
        state.image = null;
      }
    },
    DELETE_SIGNATURE(state, value) {
      state.signature = value;
    },
    DELETE_BIOMETRICS(state, value) {
      state.biometrics = value;
    },

    //Public Images for Reroute Module.
    SET_PUBLIC_IMAGE(state, imageBase64) {
      state.publicImage = imageBase64;
    },
    SET_PUBLIC_SIGNATURE(state, imageBase64) {
      state.publicSignature = imageBase64;
    },
    SET_PUBLIC_BIOMETRICS(state, imageBase64) {
      state.publicBiometrics = imageBase64;
    },
    SET_PUBLIC_VAXCERT: (state, data) => (state.publicVaxcert = data),
  },
  actions: {
    //Actions for fetching images to overlap in canvas for the printing of card.
    fetchImage({ commit }, id) {
      const url = `/citizens/${id}/files/image`;
      return this.$axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const imageBase64 = event.target.result;
              commit("SET_IMAGE", imageBase64);
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading image:", error);
              commit("SET_IMAGE", null); // Set the value to null when an error occurs
              resolve(); // Resolve the promise to prevent uncaught promise rejection
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Fetch image error:", error);
          commit("SET_IMAGE", null); // Set the value to null when an error occurs
        });
    },
    fetchSignature({ commit }, id) {
      const url = `/citizens/${id}/files/signature`;
      return this.$axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const imageBase64 = event.target.result;
              commit("SET_SIGNATURE", imageBase64);
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading image:", error);
              commit("SET_SIGNATURE", null); // Set the value to null when an error occurs
              resolve(); // Resolve the promise to prevent uncaught promise rejection
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Fetch signature image error:", error);
          commit("SET_SIGNATURE", null); // Set the value to null when an error occurs
        });
    },
    fetchBiometrics({ commit }, id) {
      const url = `/citizens/${id}/files/biometrics`;
      return this.$axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const imageBase64 = event.target.result;
              commit("SET_BIOMETRICS", imageBase64);
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading biometrics:", error);
              commit("SET_BIOMETRICS", null); // Set the value to null when an error occurs
              resolve(); // Resolve the promise to prevent uncaught promise rejection
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Fetch biometrics error:", error);
          commit("SET_BIOMETRICS", null); // Set the value to null when an error occurs
        });
    },
    fetchVaxcert({ commit }, id) {
      const url = `/citizens/${id}/files/vaxcert`;
      return this.$axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const contentType = response.headers["content-type"];
          let file_type = null;

          // Check the Content-Type to determine the type of content
          if (contentType.startsWith("image/")) {
            file_type = "Image";
          } else if (contentType === "application/pdf") {
            file_type = "PDF";
          } else {
            throw new Error("Cannot Handle These File Types");
          }

          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const file = event.target.result;
              commit("SET_VAXCERT", { file, file_type });
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading vaxcert:", error);
              commit("SET_VAXCERT", null);
              resolve();
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Error fetching vaxcert:", error);
          commit("SET_VAXCERT", null); // Set the value to null when an error occurs
        });
    },

    //Delete Actions for the removal of image in the database.
    deleteImage({ commit }, id) {
      this.$store.dispatch("loading/triggerFunctionLoader", "delete");
      const url = `citizens/${id}/files/image`;
      return this.$axios
        .delete(url)
        .then((response) => {
          const targetImage = response.data;
          commit("DELETE_IMAGE", targetImage);
          // Success Alert
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
        })
        .catch((error) => {
          console.error("Error deleting image: ", error);
          //Failed Alert
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "delete");
        });
    },
    deleteSignature({ commit }, id) {
      this.$store.dispatch("loading/triggerFunctionLoader", "delete");
      const url = `citizens/${id}/files/signature`;
      return this.$axios
        .delete(url)
        .then((response) => {
          // const targetImage = response.data;
          // console.log(targetImage);
          commit("DELETE_SIGNATURE", null);
          // Success Alert
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
        })
        .catch((error) => {
          console.error("Error deleting signature: ", error);
          //Failed Alert
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "delete");
        });
    },
    deleteBiometrics({ commit }, id) {
      this.$store.dispatch("loading/triggerFunctionLoader", "delete");
      const url = `citizens/${id}/files/biometrics`;
      return this.$axios
        .delete(url)
        .then((response) => {
          // const targetImage = response.data;
          commit("DELETE_BIOMETRICS", null);
          // Success Alert
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
        })
        .catch((error) => {
          console.error("Error deleting signature: ", error);
          //Failed Alert
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "delete");
        });
    },
    deleteVaxcert(_, id) {
      this.$store.dispatch("loading/triggerFunctionLoader", "delete");
      const url = `citizens/${id}/files/vaxcert`;
      return this.$axios
        .delete(url)
        .then((response) => {
          // Success Alert
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
          this.$store.dispatch("registrants/fetchRegistrantId", id);
        })
        .catch((error) => {
          console.error("Error deleting signature: ", error);
          //Failed Alert
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "delete");
        });
    },

    //Actions for the public images used in the reroute module.
    fetchPublicImage({ commit }, id) {
      const url = `/citizens/${id}/public-files/image`;
      return this.$axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const imageBase64 = event.target.result;
              commit("SET_PUBLIC_IMAGE", imageBase64);
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading image:", error);
              commit("SET_PUBLIC_IMAGE", null); // Set the value to null when an error occurs
              resolve(); // Resolve the promise to prevent uncaught promise rejection
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Fetch public image error:", error);
          commit("SET_PUBLIC_IMAGE", null); // Set the value to null when an error occurs
        });
    },
    fetchPublicSignature({ commit }, id) {
      const url = `/citizens/${id}/public-files/signature`;
      return this.$axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const imageBase64 = event.target.result;
              commit("SET_PUBLIC_SIGNATURE", imageBase64);
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading image:", error);
              commit("SET_PUBLIC_SIGNATURE", null); // Set the value to null when an error occurs
              resolve(); // Resolve the promise to prevent uncaught promise rejection
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Fetch public signature image error:", error);
          commit("SET_PUBLIC_SIGNATURE", null); // Set the value to null when an error occurs
        });
    },
    fetchPublicBiometrics({ commit }, id) {
      const url = `/citizens/${id}/public-files/biometrics`;
      return this.$axios
        .get(url, {
          responseType: "blob",
        })
        .then((response) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const imageBase64 = event.target.result;
              commit("SET_PUBLIC_BIOMETRICS", imageBase64);
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading public image biometrics:", error);
              commit("SET_PUBLIC_BIOMETRICS", null); // Set the value to null when an error occurs
              resolve(); // Resolve the promise to prevent uncaught promise rejection
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Fetch biometrics error:", error);
          commit("SET_PUBLIC_BIOMETRICS", null); // Set the value to null when an error occurs
        });
    },
    fetchPublicVaxcert: function ({ commit }, id) {
      const url = `/citizens/${id}/public-files/vaxcert`;
      return this.$axios
        .get(url, {
          responseType: "blob",
        })
        .then((response) => {
          const contentType = response.headers["content-type"];
          let file_type = null;

          // Check the Content-Type to determine the type of content
          if (contentType.startsWith("image/")) {
            file_type = "Image";
          } else if (contentType === "application/pdf") {
            file_type = "PDF";
          } else {
            throw new Error("Cannot Handle These File Types");
          }

          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              const file = event.target.result;
              commit("SET_PUBLIC_VAXCERT", { file, file_type });
              resolve();
            };
            reader.onerror = (error) => {
              console.error("Error loading vaxcert:", error);
              commit("SET_PUBLIC_VAXCERT", null);
              resolve();
            };
            reader.readAsDataURL(response.data);
          });
        })
        .catch((error) => {
          console.error("Fetch vaxcert error:", error);
          commit("SET_PUBLIC_VAXCERT", null); // Set the value to null when an error occurs
        });
    },
  },
};
